import React, { useState, useEffect, Fragment } from 'react'
import { Card, Table } from 'react-bootstrap'
import config from '../../config'
import Cookies from 'js-cookie'
import { useSelector } from 'react-redux'

const TempImport = () => {
  const [temp, setTemp] = useState({})
  const webConfig = useSelector((state) => state.webConfig)
  useEffect(() => {
    fetchImportTemp()
  }, [])

  const fetchImportTemp = async () => {
    try {
      const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/lotteryimport/processing?roundDate=${webConfig.roundDate}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      }).then((response) =>
        response.json(),
      )
      if (response) {
        setTemp(response)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const HEADER = ['ชื่อ zip', 'สำเร็จ', 'ไฟล์ทั้งหมด', 'ไฟล์ที่ข้าม']

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>ภาพรอเข้าสู่ระบบ</Card.Title>
        </Card.Header>
        <Card.Body>
          {Object.keys(temp).length > 0 && (
            <Table className="text-center">
              <thead>
                <tr>
                  {HEADER.map((header, i) => {
                    return <th key={i}>{header}</th>
                  })}
                </tr>
              </thead>
              <tbody>
                {temp.data.map((item, i) => {
                  return (
                    <tr key={i}>
                      <td>{item.zipName}</td>
                      <td>{item.proceededFiles}</td>
                      <td>{item.totalFiles}</td>
                      <td>{item.skippedFiles}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default TempImport
